import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackHubspotPageView } from "../../utils/hubspotUtils";

const HubspotTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    trackHubspotPageView(currentPath);
  }, [location]);

  return null;
};

export default HubspotTracker;
